import { createEvent, restore, sample } from 'effector'

import { fx } from 'src/libs'
import {
  SocialMediaItem,
  SocialMediaRequest,
  SocialMediaResponse,
} from './types'

export const socialMediaListMounted = createEvent<SocialMediaRequest>()

export const getSocialMedia = fx<SocialMediaRequest, SocialMediaResponse>({
  method: 'GET',
  url: `/partner/material/social_media`,
})

export const $socialMediaItems = restore<SocialMediaItem[]>(
  getSocialMedia.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfSocialMediaItems = restore(
  getSocialMedia.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: socialMediaListMounted,
  fn: ({ limit, page, filters }) => {
    let query = {
      limit,
      page,
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'lang'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (Object.keys(newObj).length) {
        // @ts-ignore
        query['where'] = `${JSON.stringify(newObj)}`
      }
    }

    return {
      query,
    }
  },
  target: getSocialMedia,
})
